// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "dist/js/" + chunkId + "." + {"320":"cd2852832a894aee","400":"99758015142ff04a"}[chunkId] + ".js";
};